/**
 * 折扣率：一次拉取过去 7/30/12 月 + 未来 7/30 天五组图表
 */
import { useState, useCallback, useEffect } from 'react';
import { getDiscountAnalysisFromProxy, } from '../../service/storeRevenueApi';
export function pickDiscountChart(bundle, range) {
    var _a, _b, _c, _d, _e;
    if (!bundle)
        return undefined;
    if (range === '7d')
        return (_a = bundle.last7Days) === null || _a === void 0 ? void 0 : _a.chartData;
    if (range === '30d')
        return (_b = bundle.last30Days) === null || _b === void 0 ? void 0 : _b.chartData;
    if (range === '12m')
        return (_c = bundle.last12Months) === null || _c === void 0 ? void 0 : _c.chartData;
    if (range === 'next7d')
        return (_d = bundle.next7Days) === null || _d === void 0 ? void 0 : _d.chartData;
    return (_e = bundle.next30Days) === null || _e === void 0 ? void 0 : _e.chartData;
}
var emptyAxes = {
    left: { id: 'left', position: 'left', name: '出租率', unit: '%', min: 0, max: 130 },
    right: { id: 'right', position: 'right', name: '价格', unit: '元', min: 0, max: 1000 },
    right2: { id: 'right2', position: 'right', name: '折扣率', unit: '%', min: 0, max: 100 },
};
var emptyBlock = {
    chartData: {
        categories: [],
        dataset: {
            discountRate: [],
            occupancyRate: [],
            avgListPrice: [],
            avgPrice: [],
        },
        axes: emptyAxes,
        series: [],
    },
};
var emptyBundle = {
    last7Days: emptyBlock,
    last30Days: emptyBlock,
    last12Months: emptyBlock,
    next7Days: emptyBlock,
    next30Days: emptyBlock,
};
export function useDiscountAnalysisData(storeId, options) {
    var enabled = (options === null || options === void 0 ? void 0 : options.enabled) !== false;
    var _a = useState(emptyBundle), data = _a[0], setData = _a[1];
    var _b = useState(function () { return enabled; }), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(0), refreshKey = _d[0], setRefreshKey = _d[1];
    var refresh = useCallback(function () { return setRefreshKey(function (k) { return k + 1; }); }, []);
    useEffect(function () {
        if (!enabled) {
            setLoading(false);
            setError(null);
            setData(emptyBundle);
            return;
        }
        var cancelled = false;
        setLoading(true);
        setError(null);
        getDiscountAnalysisFromProxy(storeId)
            .then(function (res) {
            if (cancelled)
                return;
            setData(res !== null && res !== void 0 ? res : emptyBundle);
        })
            .catch(function (err) {
            if (!cancelled) {
                setError(err instanceof Error ? err : new Error(String(err)));
                setData(emptyBundle);
            }
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [storeId, enabled, refreshKey]);
    return { data: data, loading: loading, error: error, refresh: refresh };
}
